export default __webpack_public_path__ + "static/media/phone3.06e59351.png";